import { DmState, initialDmState } from '../states/dm.state';
import { Action, createReducer, on } from '@ngrx/store';
import {
  clearDmMessages,
  loadMoreMyDmThread,
  loadMoreMyDmThreadSuccess,
  loadMoreThreadMessages,
  loadMoreThreadMessagesSuccess,
  loadMyDmThread,
  loadMyDmThreadError,
  loadMyDmThreadSuccess,
  loadThreadMessages,
  loadThreadMessagesError,
  loadThreadMessagesSuccess,
  readDmMessageSuccess,
  sendDmMessage,
  sendDmMessageError,
  sendDmMessageSuccess,
  setCurrentThreadID,
  setShowThreadState,
  toggleShowThreads
} from '../actions/dm.action';
import { initialThreadState, ThreadState } from '../states/thread.state';
import {
  initialMessageContainerState,
  MessageContainerState
} from '../states/message-container.state';
import { initialMessageState } from '../states/message.state';

const reducer = createReducer(
  initialDmState,

  on(setShowThreadState, (state, { value }) => ({
    ...state,
    showThreads: value
  })),

  on(toggleShowThreads, state => ({
    ...state,
    showThreads: !state.showThreads
  })),

  on(setCurrentThreadID, (state, { threadID }) => ({
    ...state,
    currentThreadID: threadID
  })),

  on(loadMyDmThread, state => ({
    ...initialDmState,
    loading: true
  })),

  on(loadMoreMyDmThread, state => ({
    ...state,
    loading: true,
    error: ''
  })),

  on(loadMyDmThreadSuccess, (state, { payload }) => {
    // let currentThreadID = state?.currentThreadID;
    // if (!state?.currentThreadID) {
    //   if (payload?.data?.length > 0) {
    //     currentThreadID = payload?.data[0].Id;
    //   }
    // }

    return {
      ...state,
      loading: false,
      pageInfo: payload?.pageInfo || null,
      threads:
        payload?.data?.map(p => {
          const thread: ThreadState = {
            ...initialThreadState,
            Id: p?.Id,
            participants: p?.participants,
            groupDetail:
              p?.participants?.filter(
                ps => ps.ID === p.groupDetail?.Admin
              )[0] || null,
            latestMessage: {
              ID: p?.latestMessage?.ID,
              body: p?.latestMessage?.body,
              creationTime: p?.latestMessage?.creationTime,
              recepientData: p?.latestMessage?.recepientData[0],
              user:
                p?.participants?.filter(
                  ps => ps.ID === p?.latestMessage?.senderData?.ID
                )[0] || null
            }
          };
          return thread;
        }) || []
    };
  }),

  on(loadMoreMyDmThreadSuccess, (state, { payload }) => {
    const update =
      payload?.data?.map(p => {
        return {
          ...initialThreadState,
          Id: p?.Id,
          participants: p?.participants,
          groupDetail:
            p?.participants?.filter(ps => ps.ID === p.groupDetail?.Admin)[0] ||
            null,
          latestMessage: {
            ID: p?.latestMessage?.ID,
            body: p?.latestMessage?.body,
            creationTime: p?.latestMessage?.creationTime,
            recepientData: p?.latestMessage?.recepientData[0],
            user:
              p?.participants?.filter(
                ps => ps.ID === p?.latestMessage?.senderData?.ID
              )[0] || null
          }
        };
      }) || [];

    return {
      ...state,
      loading: false,
      pageInfo: payload?.pageInfo || null,
      threads: state.threads.concat(update)
    };
  }),

  on(loadMyDmThreadError, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),

  on(loadThreadMessages, (state, { input }) => ({
    ...state,
    threads: state?.threads.map(thread => {
      if (thread?.Id !== input?.threadID) return thread;
      return {
        ...thread,
        messages: {
          ...thread?.messages,
          loading: true,
          error: '',
          messages: [],
          pageInfo: null
        }
      };
    })
  })),

  on(loadThreadMessagesSuccess, (state, { payload, threadID }) => {
    return {
      ...state,
      threads: state?.threads.map(thread => {
        if (thread?.Id !== threadID) return thread;

        const convertedMessages: MessageContainerState[] =
          payload?.data?.map(m => {
            return {
              ...initialMessageContainerState,
              message: {
                creationTime: m.creationTime,
                user:
                  thread?.participants?.filter(
                    p => p?.ID === m?.senderData?.ID
                  )[0] || null,
                recepientData: m?.recepientData[0] || null,
                body: m?.body,
                ID: m?.ID
              }
            };
          }) || [];

        return {
          ...thread,
          messages: {
            ...thread?.messages,
            loading: false,
            error: '',
            messages: convertedMessages?.reverse(),
            pageInfo: payload?.pageInfo || null
          }
        };
      })
    };
  }),

  on(loadThreadMessagesError, (state, { error, threadID }) => ({
    ...state,
    threads: state?.threads.map(thread => {
      if (thread?.Id !== threadID) return thread;
      return {
        ...thread,
        messages: {
          ...thread?.messages,
          loading: false,
          error: error
        }
      };
    })
  })),

  on(sendDmMessage, (state, { payload }) => {
    if (payload?.threadID === 'new') {
      return {
        ...state
      };
    } else {
      return {
        ...state,
        threads: state?.threads?.map(thread => {
          if (thread.Id !== payload?.threadID) {
            return thread;
          }
          const newMessage: MessageContainerState = {
            ...initialMessageContainerState,
            message: {
              ...initialMessageState,
              ID: payload?.tempMessageID,
              body: payload?.input?.message,
              user:
                thread?.participants?.filter(user => {
                  return user?.ID === payload?.currentUserID;
                })[0] || null
            },
            loading: true
          };
          return {
            ...thread,
            messages: {
              ...thread?.messages,
              messages: thread?.messages?.messages.concat(newMessage)
            }
          };
        })
      };
    }
  }),

  on(sendDmMessageSuccess, (state, { payload }) => {
    if (payload?.threadID === 'new') {
      return {
        ...state
      };
    } else {
      return {
        ...state,
        threads: state?.threads?.map(thread => {
          if (thread.Id !== payload?.threadID) {
            return thread;
          }
          const updatedMessage: MessageContainerState = {
            ...initialMessageContainerState,
            message: {
              ...initialMessageState,
              ID: payload?.message?.ID,
              body: payload?.message?.body,
              user:
                thread?.participants?.filter(user => {
                  return user?.ID === payload?.currentUserID;
                })[0] || null,
              recepientData: payload?.message?.recepientData[0] || null,
              creationTime: payload?.message?.creationTime
            },
            loading: false
          };

          return {
            ...thread,
            messages: {
              ...thread?.messages,
              messages: thread?.messages?.messages?.map(ms => {
                if (payload?.tempMessageID === ms?.message?.ID) {
                  return updatedMessage;
                }
                return ms;
              })
            }
          };
        })
      };
    }
  }),

  on(sendDmMessageError, (state, { payload }) => {
    if (payload?.threadID === 'new') {
      return {
        ...state
      };
    } else {
      return {
        ...state,
        threads: state?.threads?.map(thread => {
          if (thread.Id !== payload?.threadID) {
            return thread;
          }

          return {
            ...thread,
            messages: {
              ...thread?.messages,
              messages: thread?.messages?.messages?.map(ms => {
                if (payload?.tempMessageID === ms?.message?.ID) {
                  return {
                    ...ms,
                    error: payload?.error,
                    loading: false
                  };
                }
                return ms;
              })
            }
          };
        })
      };
    }
  }),

  on(clearDmMessages, state => ({
    ...state,
    threads:
      state.threads.map(thread => {
        return {
          ...thread,
          messages: null
        };
      }) || []
  })),

  on(loadMoreThreadMessages, (state, { input }) => ({
    ...state,
    threads: state?.threads.map(thread => {
      if (thread?.Id !== input?.threadID) return thread;
      return {
        ...thread,
        messages: {
          ...thread?.messages,
          loading: true,
          error: ''
        }
      };
    })
  })),

  on(loadMoreThreadMessagesSuccess, (state, { payload, threadID }) => {
    return {
      ...state,
      threads: state?.threads.map(thread => {
        if (thread?.Id !== threadID) return thread;

        const convertedMessages: MessageContainerState[] =
          payload?.data?.map(m => {
            return {
              ...initialMessageContainerState,
              message: {
                creationTime: m.creationTime,
                user:
                  thread?.participants?.filter(
                    p => p?.ID === m?.senderData?.ID
                  )[0] || null,
                recepientData: m?.recepientData[0] || null,
                body: m?.body,
                ID: m?.ID
              }
            };
          }) || [];

        return {
          ...thread,
          messages: {
            ...thread?.messages,
            loading: false,
            error: '',
            messages: convertedMessages
              ?.reverse()
              ?.concat(thread?.messages?.messages),
            pageInfo: payload?.pageInfo || null
          }
        };
      })
    };
  }),

  on(readDmMessageSuccess, (state, { threadID, message, messageID }) => ({
    ...state,
    threads: state?.threads?.map((thread: ThreadState) => {
      if (thread?.Id !== threadID) return thread;

      return {
        ...thread,
        messages: {
          ...thread?.messages,
          messages: thread?.messages?.messages.map(mp => {
            if (mp?.message?.ID !== messageID) {
              return mp;
            }
            return {
              ...mp,
              message: {
                ...mp.message,
                recepientData: {
                  ...mp.message.recepientData,
                  status: 'READ'
                }
              }
            };
          })
        }
      };
    })
  }))
);

export function DirectMessageReducer(
  state: DmState | undefined,
  action: Action
): DmState {
  return reducer(state, action);
}
